import { ReactNode } from 'react';
import { dvwTheme } from './theme';
import { GetBrandTheme } from '@leadflow/shared/theme/GetBrandTheme';

const ThemeProviderWrapper = ({ children }: { children: ReactNode }) => {
  return <GetBrandTheme brandTheme={dvwTheme}>{children}</GetBrandTheme>;
};

export default ThemeProviderWrapper;
